// src/components/Header.js
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

function Header({ lang, translations }) {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false); 
  const [isResumeModalOpen, setIsResumeModalOpen] = useState(false);
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };
  

  const handleNavClick = (e, hash) => {
    e.preventDefault();
    navigate(`/education${hash}`);

    // 先关闭菜单（小屏下点击后关闭）
    setIsOpen(false);

    setTimeout(() => {
      const anchor = document.querySelector(hash);
      if (anchor) {
        anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 0);
  };

  const isMobile = window.innerWidth <= 768;


  return (
    <header className="main-header">
      <div className="logo">{translations.name[lang]}</div>

      {/* ✅ 汉堡按钮 */}
      <button className="hamburger" onClick={toggleMenu}>
        ☰
      </button>

      {/* ✅ 加 open 类名 */}
      <nav className={`main-nav ${isOpen ? 'open' : ''}`}>
        <ul>
  <li>
    <Link to="/" onClick={() => setIsOpen(false)}>
      {translations.nav.home[lang]}
    </Link>
  </li>

  <li className="dropdown">
    {isMobile ? (
      // ✅ 移动端只要一个教育经历
      <Link to="/education" onClick={() => setIsOpen(false)}>
        {translations.nav.edu[lang]}
      </Link>
    ) : (
      // ✅ PC 端有下拉
      <>
        <Link to="/education" onClick={() => setIsOpen(false)}>
          {translations.nav.edu[lang]}
        </Link>
        <ul className="dropdown-menu">
          <li>
            <Link 
              to="/education#bachelor"
              onClick={(e) => handleNavClick(e, '#bachelor')}
            >
              {translations.education.bachelor[lang]}
            </Link>
          </li>
          <li>
            <Link 
              to="/education#master"
              onClick={(e) => handleNavClick(e, '#master')}
            >
              {translations.education.master[lang]}
            </Link>
          </li>
        </ul>
      </>
    )}
  </li>

  <li>
    <Link to="/experience" onClick={() => setIsOpen(false)}>
      {translations.nav.internship[lang]}
    </Link>
  </li>

  <li>
    <Link to="/contact" onClick={() => setIsOpen(false)}>
      {translations.nav.contact[lang]}
    </Link>
  </li>
  <li>
    <a 
      href="#resume-select" 
      onClick={(e) => {
        e.preventDefault();
        setIsResumeModalOpen(true); // 控制弹窗显示的 State
        setIsOpen(false);           // 关闭移动端菜单
      }}
    >
      {translations.nav.resume[lang]}
    </a>
  </li>
</ul>

      </nav>
      {isResumeModalOpen && (
        
        <div className="resume-modal-overlay" onClick={() => setIsResumeModalOpen(false)}>
          <div className="resume-modal-content" onClick={(e) => e.stopPropagation()}>
            <h3>{lang === 'zh' ? '选择简历版本' : 'Select Version'}</h3>
            <div className="resume-options-container">
              <Link to="/resume/en" className="resume-card" onClick={() => setIsResumeModalOpen(false)}>
                <div className="card-icon">EN</div>
                <span>English Resume</span>
              </Link>
              <Link to="/resume/zh" className="resume-card" onClick={() => setIsResumeModalOpen(false)}>
                <div className="card-icon">中</div>
                <span>中文简历</span>
              </Link>
            </div>
            <button className="modal-close-btn" onClick={() => setIsResumeModalOpen(false)}>✕</button>
          </div>
        </div>
      )}
    </header>
  );
}

export default Header;
